import { FC } from "react";
import { NotFoundWrapper } from "./NotFound.style";
import { Typography } from "@mui/material";

type INotFoundProps = {};

export const NotFound: FC<INotFoundProps> = () => {
  return (
    <NotFoundWrapper className="not-found-container">
      <Typography className="error">404</Typography>
      <Typography className="error-text">
        Oops. Not yet here. We are probably writing the help right now...
      </Typography>
    </NotFoundWrapper>
  );
};
